/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { taskFor } from 'ember-concurrency-ts';

export default class StandalonePlatformSwitchRoute extends Route {
  @service declare router: RouterService;
  @service declare finStandaloneService: FinStandaloneService;

  async afterModel() {
    await taskFor(this.finStandaloneService.initializationTask).perform();

    this.router.transitionTo('apps.app.standalone.deploy.overview');
  }
}
